import actionTypes from '../constants/action-types';

const fetchCurrentPackageComplete = () => ({
  type: actionTypes.FETCH_CURRENT_PACKAGE_COMPLETE,
});

export default fetchCurrentPackageComplete;
